<template>
  <div>
    <slick
      class="p-otherAccommodation__carousel"
      ref="slick" 
      :options="slickOptions">
      <div v-for="(accommodation, i) in otherAccommodation" class="p-otherAccommodation__slide" :key="i">
        <router-link :to="`/accommodation/${accommodation.post_name}`" class="c-accommodation layerContainer">
          <div class="c-accommodation__image">
            <img :src="accommodation.acf.main_image.url" alt="" ref="image" class="u-cover">
            <div class="c-accommodation__overlay">
              <div class="c-accommodation__background" ref="background"></div>
              <div class="c-accommodation__label">
                <div class="c-accommodation__mask">
                  <span>More Detail</span>
                </div>
              </div>
            </div>
          </div>
          <div class="c-accommodation__name">{{ accommodation.acf.acc_name }}</div>
        </router-link>
      </div>
    </slick>
    
    <div class="p-otherAccommodation__list">
      <slick
        class="p-otherAccommodation__spCarousel"
        ref="slickSp" 
        :options="slickOptionsSp">

        <div v-for="(accommodation, i) in otherAccommodation" class="p-otherAccommodation__item">
          <router-link :to="`/accommodation/${accommodation.post_name}`" class="c-accommodation">
            <div class="c-accommodation__image">
              <img :src="accommodation.acf.main_image.url" alt="" class="u-cover">
            </div>
            <div class="c-accommodation__name">{{ accommodation.acf.acc_name }}</div>
          </router-link>
        </div>
      </slick>
    </div>
    
    <!-- <ul class="p-otherAccommodation__list">
      <li v-for="(accommodation, i) in otherAccommodation" :key="i">
        <router-link :to="`/accommodation/${accommodation.post_name}`" class="c-accommodation">
          <div class="c-accommodation__image">
            <img :src="accommodation.acf.main_image.url" alt="" class="u-cover">
          </div>
          <div class="c-accommodation__name">{{ accommodation.acf.acc_name }}</div>
        </router-link>
      </li>
    </ul> -->
  </div>
</template>

<script>
  import 'rgbaster'
  import Slick from 'vue-slick';
  import '../../node_modules/slick-carousel/slick/slick.css';

  /**
   * Share Partial
   */

  export default {
    name: 'other-accommodation',
    components: {
      Slick,
    },
    data() {
      return {
        colors: [],
        otherAccommodation: [],
        slickOptions: {
          autoplay: true,
          autoplaySpeed: 0,
          speed: 10000,
          arrows: false,
          slidesToShow: 3,
          cssEase: 'linear',
          swipe: false,
        },
        slickOptionsSp: {
          autoplay: true,
          autoplaySpeed: 5000,
          infinite: true,
          slidesToShow: 4,
          speed: 1200,
          responsive: [
            {
              breakpoint: 1023,
              settings: {
                slidesToShow: 1,
                centerMode: true,
                centerPadding: '44px',
              }
            },
          ]
        }
      }
    },
    props: {
      accommodations: {
        type: Array,
        required: true,
      },
      postId: {
        type: [String, Number],
      }
    },
    watch: {
      accommodations(val) {
        this.otherAccommodation = this.accommodations.filter((accommodation) => {
          return String(accommodation.ID) !== String(this.postId)
        })

        if(val.length) {
          this.$refs.slick.destroy()
          this.$refs.slickSp.destroy()
          
          this.$nextTick(() => {
            this.$refs.slickSp.create()

            if(val.length > 3) {
              this.$refs.slick.create();
            }
            
            this.setLayer()
          })
        }
      }
    },
    computed: {
    },
    created() {
    },
    mounted() {
    },
    methods: {
      setLayer() {
        let accommodations = this.$el.querySelectorAll('.layerContainer')

        ;[].forEach.call(accommodations, (accommodation) => {
          let image = accommodation.querySelector('img')
          let background = accommodation.querySelector('.c-accommodation__background')

          global.RGBaster.colors(image, {
            exclude: [
              'rgb(255,255,255)',
              'rgb(0,0,0)',
            ],
            success: (payload) => {
              background.style.backgroundColor = payload.dominant
            }
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/partial/other-accommodation.vue